<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <h2>优惠券推送</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="优惠券名称" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入优惠券名称"></el-input>
          </el-form-item>

          <el-form-item label="推荐方式" prop="typeFlag">
            <el-select v-model="searchForm.recommendType" placeholder="请选择推荐方式" filterable clearable>
              <el-option v-for="item in this.dictionaries.recommend_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类目" prop="categoryIds">
            <el-cascader style="width: 232px" :options="categoryIds" v-model="searchForm.categoryId"
              popper-class="optionC" placeholder="请选择类目"
              :props="{ checkStrictly: true, multiple: false, emitPath: false }" collapse-tags clearable></el-cascader>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" placeholder="请选择状态" filterable clearable>
              <el-option v-for="item in statuss" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('search')">查询</el-button>
            <el-button type="primary" plain @click="getList('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div style="display: flex; align-items: center;justify-content: space-between;">
          <h3>列表数据</h3>
          <div style="display:flex">
            <div class="u-btn" @click="deleteS('lotsof')">批量删除</div>
            <el-button type="primary" @click="add('add')" icon="el-icon-plus" size="small">新增</el-button>
          </div>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="list" pagination
          :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
      <el-dialog :title="optionsPush" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogPush"
        width="518px">
        <el-form ref="pForm" label-width="80px" class="info-form" :rules="rules1" :model="pForm">
          <el-form-item label="推荐方式" prop="recommendType">
            <el-select style="width: 100%" v-model="pForm.recommendType" placeholder="请选择推荐方式">
              <el-option v-for="item in this.dictionaries.recommend_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发放卡券" prop="couponId">
            <el-select style="width: 100%" v-model="pForm.couponId" placeholder="请选择发放卡券" @change="changeCoupon">
              <el-option v-for="item in fcoupons" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="绑定类目" prop="categoryList1">
            <el-cascader style="width: 100%" :options="categoryIds" v-model="pForm.categoryList1" placeholder="请选择绑定类目"
              @change="selectCType($event)" ref="cascader"
              :props="{ checkStrictly: false, multiple: true, emitPath: false }" collapse-tags clearable></el-cascader>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input placeholder="请输入排序" v-model="pForm.sort" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="p-info">注：序号数字越小，显示位置越靠前</div>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="pForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="dialogPush = false">取消</div>
          <div class="info-s" @click="submitP">确定</div>
        </div>
      </el-dialog>
      <el-dialog :title="statusTitle" :visible.sync="isS" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
        <template>
          <div class="info" style="text-align: left" v-if="statusTitle == '禁用信息'">
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认禁用该优惠券？
          </div>
          <div class="info" style="text-align: left" v-else>
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认启用该优惠券？
          </div>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-q" @click="isS = false">取消</div>
            <div class="info-s" @click="submitA">确定</div>
          </div>
        </template>
      </el-dialog>
      <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
        <template>
          <div class="info" style="text-align: left" v-if="isSingle != 'single'">
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认删除选中的{{ deleteIds.length }}个优惠券？
          </div>
          <div class="info" style="text-align: left" v-else>
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认删除该优惠券？
          </div>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-q" @click="isD = false">取消</div>
            <div class="info-s" @click="submitD">确定</div>
          </div>
        </template>
      </el-dialog>
      <el-dialog title="生成二维码" :visible.sync="isQcode" width="518px" :append-to-body="true">
        <template>
          <div style="margin-left: 139px;">
            <img :src="qCode" style="width: 200px;height: 200px;" />
          </div>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-s"><a :href="qrInfoDown" style="color:white;text-decoration: none;">导出</a>
            </div>
          </div>
        </template>
      </el-dialog>
      <el-dialog title="发放优惠券" :visible.sync="isCoupon" width="60%" :append-to-body="true">
        <template>
          <div>
            <el-radio-group v-model="couponForm.userSelectType" @change="selectType">
              <el-radio-button label="0">用户发放</el-radio-button>
              <el-radio-button label="1">层级发放</el-radio-button>
            </el-radio-group>
          </div>
          <div style="display: flex;margin-top: 24px;" v-if="couponForm.userSelectType == 0">
            <div class="dialog-search" style="display: flex;">
              <div>
                <el-input placeholder="请输入用户信息" clearable v-model="keywords" style="width: 232px;"
                  size="small"></el-input>
              </div>
              <div style="margin-left: 20px;">
                <el-button type="primary" @click="getfindVipCustomerPage" size="small">查询</el-button>
              </div>
            </div>
          </div>
          <div style="display: flex;" v-if="couponForm.userSelectType == 0">
            <div style="width: 48%;">
              <el-table :data="tableData" tooltip-effect="dark" row-key="id" ref="multipleTable"
                :header-cell-style="{ 'background': '#f8f8f8', 'color': '#333333' }"
                @selection-change="handleSelectionChange" style="width: 100%; margin-top: 20px;">
                <el-table-column type="selection" :reserve-selection="true" width="55">
                </el-table-column>
                <el-table-column label="用户ID" prop="id"> </el-table-column>
                <el-table-column label="用户昵称" prop="name">
                </el-table-column>
                <el-table-column prop="phone" label="手机号码" show-overflow-tooltip>
                </el-table-column>
              </el-table>
              <div style="margin-top: 10px">
                <el-pagination style="text-align: center;" @size-change="cHandleSizeChange"
                  @current-change="cHandleCurrentChange" :current-page="cPageNo" :page-sizes="[10, 20, 30, 40]"
                  :page-size="cPageSize" layout="prev, pager, next" :total="cTotalNum">
                </el-pagination>
              </div>
            </div>
            <div style="width: 10px;margin-left: 10px;">
              <div style="width:0px;height: 100%;border: 1px solid #EBEBFA;opacity: 1;"></div>
            </div>
            <div style="width: 48%;">
              <div
                style="height: 21px;font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;line-height: 21px;color: #303033;">
                已选用户（{{ tableData1.length || 0 }}）</div>
              <el-table :data="pageData" tooltip-effect="dark"
                :header-cell-style="{ 'background': '#f8f8f8', 'color': '#333333' }"
                style="width: 100%; margin-top: 20px;">
                <el-table-column label="用户ID" prop="id"> </el-table-column>
                <el-table-column label="用户昵称" prop="name">
                </el-table-column>
                <el-table-column prop="phone" label="手机号码" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="phone" label=" ">
                  <template slot-scope="scope">
                    <div style="text-align: center;" @click="del(scope.$index, scope.row)">
                      <img src="../../../assets/icon_del_nor.png" style="width:20px;height: 20px;" />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 10px">
                <el-pagination style="text-align: center;" @size-change="cHandleSizeChange1"
                  @current-change="cHandleCurrentChange1" :current-page="cPageNo1" :page-size="cPageSize1"
                  layout="prev, pager, next" :total="tableData1.length">
                </el-pagination>
              </div>
            </div>
          </div>
          <div v-if="form.userSelectType == 1" style="margin-top:30px;font-size: 24px;">功能开发中</div>
          <el-form :rules="rules" ref="couponForm" :model="couponForm" style="margin-top: 20px;">
            <el-form-item label="发放卡券" prop="couponId" style="margin-top: 20px;">
              <el-select v-model="couponForm.couponId" placeholder="请选择卡券" filterable clearable style="width:348px">
                <el-option v-for="item in coupons" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发放数量" prop="num" style="margin-top: 20px;">
              <el-input v-model.number="couponForm.num" placeholder="请输入发放数量" style="width:348px">
              </el-input>
            </el-form-item>
          </el-form>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-q" @click="isCoupon = false">取消</div>
            <div class="info-s" @click="submitC">确定</div>
          </div>
        </template>
      </el-dialog>
    </div>

  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data() {
    return {
      dialogPush: false,
      optionsPush: '新增推送',
      couponForm: {
        couponId: '',
        num: null,
        userSelectType: '0'
      },
      rules: {
        couponId: [
          { required: true, message: '请选择发放卡券', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '请输入发放数量', trigger: 'blur' }
        ],
      },
      pForm: {
        recommendType: '',
        couponId: '',
        name: '',
        id: '',
        sort: '',
        status: '',
        categoryList: [],
        categoryList1: []
      },
      rules1: {
        recommendType: [
          { required: true, message: '请选择推荐方式', trigger: 'change' },
        ],
        couponId: [
          { required: true, message: '请选择优惠券', trigger: 'change' }
        ],
        categoryList1: [
          { required: true, message: '请选择类目', trigger: 'change' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      coupons: [],
      fcoupons: [],
      keywords: '',
      tableData: [],
      tableData1: [],
      form: {
        userSelectType: '0'
      },
      isCoupon: false,
      isQcode: false,
      qCode: '',
      isD: false,
      dataList: {
        list: [
          { title: '营销管理', path: '', type: '0' },
          { title: '优惠券管理', path: '', type: '1' }
        ]
      },
      searchForm: {
        name: '',
        typeFlag: '',
        pageNo: 1,
        pageSize: 10,
        // bindUserInfo: null,
        categoryId: ''
      },
      openTime: [],
      statuss: [
        {
          id: '1',
          name: '已启用'
        },
        {
          id: '0',
          name: '已禁用'
        }
      ],
      list: [

      ],
      columns: [
        { type: 'selection', width: '80', fixed: 'left' },
        { label: '排序', prop: 'sort', idth: '80' },
        { label: 'ID', prop: 'id', width: '80' },
        { label: '推荐方式', prop: 'recommendTypeLabel', minWidth: '120' },
        {
          label: '绑定类目', prop: 'categoryLabel', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p style="max-height: 120px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;">{scope.row.categoryLabel ? scope.row.categoryLabel : '--'}</p>
              </div>
            )
          }
        },
        { label: '优惠券名称', prop: 'name', minWidth: '200' },
        { label: '优惠券价值', prop: 'worth', minWidth: '120' },

        { label: '已领取数量', prop: 'alreadyGet', minWidth: '120', },
        {
          label: '状态', prop: 'statusLabel', minWidth: '130',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.status == '1') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusL}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusL}</div>
              </p>
            }
            return (
              <div> {vv}</div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '180',
          fixed: 'right',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.status == '1') {
              vv = '禁用'
            } else {
              vv = '启用'
            }
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add('edit', scope.row.id) }}>编辑</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.changeStatus(scope.row) }}>{vv}</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deleteS('single', scope.row.id) }}>删除</span>
                {/* <el-link size='mini' type='primary' onClick={() => { this.add('edit', scope.row.id) }}>查看</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('use', scope.row.id) }}>使用详情</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('receive', scope.row.id) }}>领取详情</el-link> */}
              </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      categoryList: [],
      dictionaries: {},
      loading: false,
      isSingle: 'single',
      isS: false,
      deleteIds: [],
      selectionCoupons: [],
      qrInfo: '',
      qUrl: '',
      qrInfoDown: '',
      cPageNo: 1,
      cPageSize: 6,
      cTotalNum: 0,
      cPageNo1: 1,
      cPageSize1: 6,
      selectTemArr: [],
      pageData: [],
      categoryIds: [],
      allValues: [], // 用于存储所有可能的值
      pType: '',
      statusTitle: '',
      cId: '',
      cStatus: ''
    }
  },
  created() {
    this.getCategoryList()
    this.getDictionaries('recommend_type')
    this.getList()
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'couponDetail') {
      next(vm => {
        vm.getList();
      });
    } else {
      next(vm => {
        vm.getList();
      });
    }
  },
  mounted() {

  },
  methods: {
    changeCoupon(e) {
      console.log(e)
      this.fcoupons.forEach(item => {
        if (item.id == e) {
          this.pForm.name = item.name
        }
      })
      console.log(this.pForm.name)
    },
    submitA() {
      let data = {
        id: this.cId,
        status: this.cStatus
      }
      this.axios.post('/couponRecommend/changeStatus', data).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.isS = false
          this.getList();
        }
      })
    },
    //更改状态
    changeStatus(row) {
      this.isS = true
      this.cId = row.id;

      if (row.status == 1) {
        this.statusTitle = '禁用信息'
        this.cStatus = 1
      } else {
        this.statusTitle = '启用信息'
        this.cStatus = 0
      }
    },
    flattenOptions(options) {
      options.forEach((option) => {
        if (option.level == 3 || (option.level == 2 && !option.children) || (option.level == 1 && !option.children)) {
          this.allValues.push(option.id);
        }
        // this.allValues.push(option.id);
        if (option.children) {
          this.flattenOptions(option.children);
        }
      });
    },
    selectCType(e) {
      // console.log(e, this.allValues.length)
      if (this.allValues.length === e.length) {
        console.log('全选了');
        this.pForm.categoryType = 1
      } else {
        console.log('未全选');
        this.pForm.categoryType = 2
      }
    },
    getCategoryList() {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        // categoryName: '',
        // categoryNo: '',
        // status: null
      }
      this.axios.post('/category/pageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.categoryIds = res.data.list
            this.flattenOptions(this.categoryIds)
          }
        })
    },
    submitP() {
      this.$refs['pForm'].validate((valid) => {
        if (valid) {
          let arr = []
          this.pForm.categoryList1.forEach(item => {
            let obj = {
              categoryId: item
            }
            arr.push(obj)
          })
          this.pForm.categoryList = arr
          console.log(this.pForm.categoryList)
          this.axios.post('/couponRecommend/addEdit', this.pForm)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                if (this.pType == 'add') {
                  this.$message.success('新增成功')
                } else {
                  this.$message.success('编辑成功')
                }
                this.getList();
                this.dialogPush = false
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitC() {
      this.$refs['couponForm'].validate((valid) => {
        if (valid) {
          let userIds = []
          this.tableData1.forEach(item => {
            userIds.push(item.id)
          })
          let data = {
            userSelectType: this.couponForm.userSelectType,
            couponId: this.couponForm.couponId,
            num: this.couponForm.num,
            userIds: userIds
          }
          this.axios.post('/coupon/batchDistribute', data)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                this.$message.success('发放成功')
                this.isCoupon = false
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    del(index, row) {
      this.tableData1.splice(index, 1)
      let arr = []
      arr.push(row)
      arr.forEach((item) => {
        this.$refs.multipleTable.toggleRowSelection(item, false);
      });
      // this.$nextTick(() => {
      //   this.tableData.forEach(item => {
      //     if (item.id == row.id) {
      //       this.$refs.multipleTable.toggleRowSelection(item, false)
      //     }

      //   })
      // })
      this.pageData = this.queryByPage()
    },
    getfindVipCustomerPage() {
      this.cPageNo = 1
      this.getUser()
    },
    // 实现分页的方法
    queryByPage() {
      // 起始位置 = (当前页 - 1) x 每页的大小
      const start = (this.cPageNo1 - 1) * this.cPageSize1
      // 结束位置 = 当前页 x 每页的大小
      const end = this.cPageNo1 * this.cPageSize1

      return this.tableData1.slice(start, end)
    },
    handleSelectionChange(val) {
      console.log(val)
      // this.tableData1 = Array.from(new Set(val.concat(this.tableData1)))
      this.tableData1 = val.reverse()
      this.pageData = this.queryByPage()
    },
    cHandleCurrentChange1(currentChange) {
      this.cPageNo1 = currentChange
      this.pageData = this.queryByPage()
    },
    cHandleSizeChange1(sizeChange) {
      this.cPageSize1 = sizeChange
      this.pageData = this.queryByPage()
    },
    selectType(val) {
      this.form.userSelectType = val
    },
    fCoupon() {
      this.isCoupon = true
      this.keywords = ''
      this.tableData1 = []
      this.pageData = this.queryByPage()
      this.$nextTick(() => {
        this.tableData.forEach(item => {
          this.$refs.multipleTable.toggleRowSelection(item, false)
        })

      })
      this.couponForm.couponId = ''
      this.couponForm.num = ''
      this.getUser()
      this.axios.post('/coupon/pageList', {
        pageNo: 1,
        pageSize: 100000,
      }).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.showFlag == 1) {
              item.showFlagL = '是'
            } else {
              item.showFlagL = '否'
            }
          })
          this.coupons = res.data.list
        }
      })
    },
    getUser() {
      this.axios.get('/user/search/list?keywords=' + this.keywords + '&pageNo=' + this.cPageNo + '&pageSize=' + this.cPageSize).then(res => {
        if (res.code == 0) {
          if (res.data.list.length > 0) {
            this.tableData = res.data.list
            this.cTotalNum = res.data.totalNum
          } else {
            this.tableData = []
            this.cTotalNum = 0
          }
        }
      })
    },
    deliveDetail(id) {
      this.$router.push({
        name: 'receiveDetail',
        query: {
          id: id
        }
      })
    },
    exportPng() {
      this.axios.get('/coupon/getCouponQrInfoDown?qrInfo=' + encodeURI(this.qrInfo)).then(res => {
        if (res.code == 0) {
          // this.qCode = res.data.url
        }
      })
    },
    lookQCode(qrInfo, qrInfoDown) {
      this.qrInfo = qrInfo
      this.qrInfoDown = qrInfoDown
      this.isQcode = true
      this.axios.post('/coupon/getCouponQrInfo', { qrInfo: qrInfo }).then(res => {
        if (res.code == 0) {
          this.qCode = res.data.url
        }
      })
    },
    deleteS(type, id) {

      this.isSingle = type
      this.deleteIds = []
      if (this.isSingle == 'single') {
        this.isD = true
        this.deleteIds.push(id)
      } else {

        if (this.selectionCoupons.length == 0) {
          this.$message.warning('请选择优惠券')
        } else {
          this.isD = true
          this.selectionCoupons.forEach(item => {
            this.deleteIds.push(item.id)
          })
        }
      }
    },
    submitD() {
      let data = {
        ids: this.deleteIds
      }
      this.axios.post('/couponRecommend/delete', data).then(res => {
        if (res.code == 0) {
          this.isD = false
          this.$message.success('删除成功')
          this.getList()
        }
      })
    },
    //导出
    deriveDeliver() {
      this.$api.exportPlatformsList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onChangeCategory() {

    },
    onMultipleSelection(val) {
      this.selectionCoupons = val
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },
    cHandleCurrentChange(currentChange) {
      this.cPageNo = currentChange
      this.getUser()
    },
    cHandleSizeChange(sizeChange) {
      this.cPageSize = sizeChange
      this.getUser()
    },
    getList(type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      this.axios.post('/couponRecommend/pageList', this.searchForm).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusL = '已启用'
            } else {
              item.statusL = '已禁用'
            }
          })
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false;
        }
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.axios.get('/getDictGroup?groupId=' + type).then((res) => {
        this.dictionaries['recommend_type'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // // 获取类目列表
    // getCategoryList() {
    //   const params = {}
    //   this.$api.categoryList(params).then((res) => {
    //     res.data.list.forEach(item => {
    //       if (item.children) {
    //         item.children.forEach(itm => {
    //           if (itm.children) {
    //             delete itm.children
    //           }
    //         })
    //       }
    //     })
    //     this.categoryList = res.data.list
    //   }).catch((err) => {
    //     console.log(err)
    //   })
    // },
    add(type, id) {
      this.dialogPush = true
      this.pType = type
      this.getcList()
      if (this.$refs['pForm']) {
        this.$refs['pForm'].clearValidate()
        this.$refs['pForm'].resetFields()
      }
      if (type == 'add') {
        this.optionsPush = '新增推送'
        this.pForm.categoryList = []
        this.pForm.categoryList1 = []
        this.pForm.couponId = ''
        this.pForm.recommendType = ''
        this.pForm.sort = ''
        this.pForm.status = ''
        this.pForm.id = ''
        // this.$refs['pForm'].clearValidate()
        // this.$refs['pForm'].resetFields()
        // if (this.$refs['pForm']) {
        //   this.$refs['pForm'].clearValidate()
        // }
      } else {
        this.optionsPush = '编辑推送'
        this.pForm.id = id
        this.getPdetail(id)
      }

      // this.$router.push({
      //   name: 'recommendCouponDetail',
      //   query: {
      //     type: type,
      //     id: id
      //   }
      // })

    },
    getPdetail(id) {
      this.pForm.categoryList = []
      this.axios.post('/couponRecommend/getInfo', {
        id: id,
      }).then(res => {
        if (res.code == 0) {
          res.data.recommendType = String(res.data.recommendType)
          this.pForm = res.data
          let arr = []
          if (res.data.categoryType == 1) {
            arr = this.allValues
          } else {
            res.data.categoryList.forEach(item => {
              let str = item.categoryId
              arr.push(str)
            })
          }

          this.pForm.categoryList1 = arr
          console.log(this.pForm.categoryList1)

        }
      })
    },
    getcList() {
      this.axios.post('/couponRecommend/getCoupon', { name: '' }).then(res => {
        if (res.code == 0) {
          this.fcoupons = res.data
        }
      })
    },
    setting() {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
</script>
<style  lang="scss">
.optionC {
  .el-cascader-panel {
    .el-scrollbar:first-child {
      .el-checkbox {
        display: none;
      }
    }
  }
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

.el-cascader__suggestion-item.is-checked {
  color: #2d46ee;
  font-weight: 700;
}
</style>
<style scoped lang="scss">
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}

::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  // display: flex;
  // justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #303033;
  opacity: 1;
  text-align: center;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.u-btn {
  width: 92px;
  height: 34px;
  background: #FFFFFF;
  border: 1px solid #2D46EE;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #2D46EE;
  text-align: center;
  cursor: pointer;
  margin-right: 18px;
}

.c-btn {
  width: 106px;
  height: 36px;
  background: #FF9226;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
  margin-right: 18px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  